import React from 'react';

import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';

import { InvisibleNotificationProps } from '../InteractionInfo';
import { useSendPrivateMessage } from './useSendPrivateMessage';

export const InvisibleNotification: React.FC<InvisibleNotificationProps> = withWebinarPlayerContext(
  ['ewebinar', 'playbackPositionRef', 'mode', 'locale']
)(({ interaction, attendee, context }) => {
  useSendPrivateMessage(interaction, attendee, context);
  return null;
});
